<template>
  <div class="serveDetail">
    <navigation></navigation>
    <div style="width: 100%; height: 80px"></div>

    <!-- 面包屑导航 -->
    <div style="width: 1200px; margin: 0 auto">
      <div class="crumbs">
        <span>当前位置：</span>
        <span @click="toHome">首页 ></span>
        <span @click="toServe">服务 ></span>
        <span @click="toServeList">{{ catalogueName }} ></span>
        <span style="color: #333333">服务详情</span>
      </div>
    </div>

    <div class="head">
      <img :src="data.coverImg" alt="" />
      <div class="text">
        <div class="text-b">{{ data.servicesName }}</div>
        <div
          class="text-s"
          v-for="(item, index) in data.customModels"
          :key="index"
        >
          <span v-html="item.key">{{ item.key }}:</span
          ><span>{{ item.value }}</span>
        </div>

        <!-- <div class="text-b">{{data.activityName}}</div>
                <div class="text-s" v-for="(item, index) in data.customModels" :key='index' v-if="index != data.customModels.length-1 && index != data.customModels.length-2">
                    <span>{{item.key}}:</span><span>{{item.value}}</span>
                </div>
                <div class="text-s" v-if="data.customModels" style="float:left;">
                    <span>{{data.customModels[data.customModels.length-2].key}}:</span><span>{{data.customModels[data.customModels.length-2].value}}</span>
                </div>
                <div class="text-s" v-if="data.customModels" style="float:left;margin-left:50px;">
                    <span>{{data.customModels[data.customModels.length-1].key}}:</span><span>{{data.customModels[data.customModels.length-1].value}}</span>
                </div> -->
        <div style="clear: both"></div>
        <div style="width: 100%; height: 80px"></div>
        <button class="zixunbtn"><span class="zixunspan"></span>咨询</button>
        <button class="ljbmbtn">立即报名</button>
      </div>
    </div>
    <div class="serveDetails">
      <div class="blueLine"></div>
      <div class="serveDetailsCH">服务详情</div>
      <div class="serveDetailsEN">Service details</div>
      <div class="article" ref="remark" v-html="data.remark"></div>
      <div style="clear: both"></div>
    </div>
  </div>
</template>

<script>
// import helloworld from '@/components/helloworld.vue' //引入组件
import navigation from "@/components/common/navigation";

export default {
  name: "serveDetail",
  components: {
    navigation,
  },
  data() {
    return {
      data: {},
      catalogueName: this.$route.query.catalogueName,
      catalogueId: this.$route.query.catalogueId,
    };
  },
  methods: {
    toServe() {
      this.$router.push("/serve");
    },
    toHome() {
      sessionStorage.setItem("tabIndex", 1);
      this.$router.push("/");
    },
    toServeList() {
      // let id = this.$route.query.catalogueId;
      this.$router.push({
        path: "/serveList",
        query: {
          id: this.catalogueId,
        },
      });
    },
    outoHeightFn() {
      setTimeout(() => {
        let dom = this.$refs.remark;
        const height = this.$refs.remark.offsetHeight;
        if (height < 300) {
          dom.style.height = "300px";
        }
      }, 300);
    },
  },
  created() {
    let servicesId = this.$route.query.servicesId;
    this.$axios
      .post("/v1/cloud/common/services/details", {
        servicesId,
      })
      .then(({ data }) => {
        if (data) {
          this.data = data;
        }
      })
      .catch((error) => {
        this.$message({
          message: error.response.data.message,
          type: "warning",
        });
      });
  },
  mounted() {
    //滚动条从顶部开始
    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (osTop > 0) {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    }

    //内容详情高度样式适配
    this.outoHeightFn();
  },
};
</script>

<style scoped lang="less">
.serveDetail {
  width: 100%;
  // position: relative;
  background-color: #F5F5F5;
  padding-bottom: 100px;
  .crumbs {
    width: 350px;
    font-size: 14px;
    margin-top: 20px;
    span {
      float: left;
      font-style: 12px;
      cursor: pointer;
      margin-left: 5px;
      color: #666666;
      font-family: MicrosoftYaHei;
    }
  }
  .head {
    width: 1200px;
    height: 340px;
    margin: 60px auto 0;
    padding: 20px;
    box-sizing: border-box;
    background-color: #fff;
    img {
      width: 470px;
      height: 300px;
      float: left;
    }
    .text {
      width: 660px;
      float: right;
      margin-left: 30px;
      padding-top: 14px;
      .text-b {
        font-size: 24px;
        line-height: 24px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: #333333;
        margin-bottom: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .text-s {
        span:first-of-type {
          font-size: 16px;
          color: #999999;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          line-height: 38px;
        }
        span:last-of-type {
          font-size: 16px;
          color: #333333;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          margin-left: 10px;
          line-height: 38px;
        }
        // >span{
        //     display: block;
        //     font-size: 18px;
        //     color: #999999;
        //     margin-top: 10px;
        //     span{
        //         color:#333333;
        //     }
        //     .people{
        //         margin-right: 50px;
        //     }
        //     .money{
        //         font-size: 24px;
        //         color: #FD6114;
        //     }
        // }
      }
      .zixunspan {
        width: 18px;
        height: 14px;
        display: inline-block;
        background-image: url('../../static/server/zixunicon.png');
        background-size: 18px 14px;
        vertical-align: middle;
        margin-right: 9px;
      }
      button {
        width: 140px;
        height: 40px;
        border: 1px solid #3476C1;
        background-color: #fff;
        font-style: 16px;
        font-family: MicrosoftYaHei;
        outline: none;
        font-weight: 400;
        // margin-top: 15px;
        margin-right: 30px;
        color: #3476C1;
        border-radius: 3px;
        cursor: pointer;
      }
      button.ljbmbtn {
        background-color: #3476C1;
        color: #fff;
      }
    }
  }
  .serveDetails {
    // height: 1000px;
    height: auto;
    width: 1200px;
    margin: 20px auto 0;
    // margin-top: 50px;
    padding: 40px 25px;
    box-shadow: 0px 20px 50px 0px #F5F5F5;
    background-color: #fff;
    .blueLine {
      width: 4px;
      height: 20px;
      background: #3476C1;
      float: left;
      margin-top: 7px;
    }
    .serveDetailsCH {
      float: left;
      // width:78px;
      // height:19px;
      font-size: 20px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #333333;
      margin-left: 10px;
      margin-top: 7px;
      line-height: 20px;
    }
    .serveDetailsEN {
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #999999;
      float: left;
      margin-left: 10px;
      margin-top: 8px;
    }
    .article {
      width: 100%;
      float: left;
      height: auto !important;
      font-style: 14px;
      margin-top: 20px;
      text-align: justify;
      font-family: MicrosoftYaHei;
      color: #666666;
    }
  }
}
</style>